import { render, staticRenderFns } from "./ManagerTab.vue?vue&type=template&id=bff63f9c&scoped=true&"
import script from "./ManagerTab.vue?vue&type=script&lang=js&"
export * from "./ManagerTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagerTab.vue?vue&type=style&index=0&id=bff63f9c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff63f9c",
  null
  
)

export default component.exports